module.exports = __webpack_public_path__ + "img/frame (243).f74d7618.jpg";